import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { StyleSheet, View } from 'react-native';
import StatusBar from 'design-system/StatusBar';
import { AppView } from 'design-system/AppView';
import { useAppSelector } from 'store/hooks';
import useColors from 'hooks/useColors';
import { MySpacesPage } from './containers';
import { selectHasSpaces, selectSpaces, selectFetchingMySpaces, } from './reducers/selectors';
import { isWeb } from '../../constants';
const MySpaces = ({ navigation }) => {
    const colors = useColors();
    const spaces = useAppSelector(selectSpaces);
    const hasSpaces = useAppSelector(selectHasSpaces);
    const fetchingMySpaces = useAppSelector(selectFetchingMySpaces);
    useLayoutEffect(() => {
        if (!isWeb || !fetchingMySpaces) {
            navigation.setOptions({
                headerTintColor: colors.text.primary,
            });
        }
    }, [
        colors.elements.secondary,
        colors.text.primary,
        colors.text.white,
        fetchingMySpaces,
        hasSpaces,
    ]);
    const timeoutRef = useRef(undefined);
    useEffect(() => () => {
        clearTimeout(timeoutRef.current);
    }, []);
    return (<AppView type="primary" withFrame={false}>
      <View style={styles.container}>
        <StatusBar barStyle="dark-content" animated/>
        <MySpacesPage spaces={spaces} isLoading={fetchingMySpaces}/>
      </View>
    </AppView>);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});
export default MySpaces;
